/**
 * Global Quantity Button Handler
 * Ensures +/- buttons work even when cart content is replaced via innerHTML
 */

document.addEventListener('click', function(event) {
  // Find button - handle clicks on button itself or child elements (like SVG icons)
  let target = event.target;
  if (target.tagName === 'svg' || target.tagName === 'path') {
    target = target.closest('button');
  }

  const button = target.closest ? target.closest('button[name="plus"], button[name="minus"]') : null;

  if (!button) return;
  if (button.name !== 'plus' && button.name !== 'minus') return;

  // Check if button is disabled
  if (button.disabled || button.classList.contains('disabled')) return;

  const quantityInput = button.closest('quantity-input');
  if (!quantityInput) return;

  const input = quantityInput.querySelector('input[type="number"]');
  if (!input) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const previousValue = parseInt(input.value) || 1;

  if (button.name === 'plus') {
    input.stepUp();
  } else if (button.name === 'minus') {
    input.stepDown();
  }

  const newValue = parseInt(input.value);

  if (previousValue !== newValue) {
    const changeEvent = new Event('change', { bubbles: true });
    input.dispatchEvent(changeEvent);
  }
}, true); // Use capture phase to catch event before other handlers
